import { defineMessages } from 'react-intl';

export default defineMessages({
  success: {
    id: 'profile.success',
    defaultMessage: 'Successfully saved your changes.',
  },
});
